import * as helper from './../../../Assets/Js/helper';

export function ImageHover(nodes:NodeListOf<HTMLDivElement>) {
	nodes.forEach((node) => {
		let timer;

		const switchToNextImage = (node:HTMLDivElement) => {
			const currentImage = node.querySelector('img.in');
			let nextImage = currentImage.nextElementSibling;
			if (nextImage === null) {
				nextImage = node.querySelector('img');
			}

			if (currentImage !== nextImage) {
				helper.removeClass(currentImage, 'in');
				helper.removeClass(nextImage, 'out');
				helper.addClass(currentImage, 'out');
				helper.addClass(nextImage, 'in');
			}
		}

		helper.addEventListener(node, 'mouseenter', () => {
			switchToNextImage(node);
			timer = setInterval(switchToNextImage.bind(this, node), 4000);
		})
		helper.addEventListener(node, 'mouseleave', () => {
			clearInterval(timer);
		})
	})
}
